import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiResponse } from '../../models/common.model';
import { loadFilteredCommunityProducts, loadFilteredCommunityProductsFailure, loadFilteredCommunityProductsSuccess } from './filtered-community-product.action';
import { CustomerService } from '../../services/customer.service';

@Injectable()
export class FilteredCommunityProductEffects {
  constructor(private actions$: Actions, private customerService: CustomerService) { }

  // Effect to load filtered products
  loadFilteredCommunityProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadFilteredCommunityProducts),
      switchMap((action: { categoryId?: string; subRegionId?: any; basedProduct?: any, search?: any }) =>
        this.customerService.getMemberShopProductList({
          categoryId: action.categoryId,
          subRegionId: action.subRegionId,
          basedProduct: action.basedProduct,
          search: action.search,
        }).pipe(
          map((response: ApiResponse) => {
            return loadFilteredCommunityProductsSuccess({ filteredProducts: response.body });
          }),
          catchError((error) =>
            of(
              loadFilteredCommunityProductsFailure({
                error: {
                  message: error.message || 'An unknown error occurred',
                  statusCode: error.status || 500,
                },
              })
            )
          )
        )
      )
    )
  );
}
